import { EndpointKey } from '../types/uploadEndpoint';

export interface IUploadEndpointOption {
  value: EndpointKey;
  labelKey: string;
}

export const UPLOAD_ENDPOINT_OPTIONS: IUploadEndpointOption[] = [
  { value: 'default', labelKey: 'uploadEndpoint.option1' },
  { value: 'ipv4', labelKey: 'uploadEndpoint.option2' },
  { value: 'ipv6', labelKey: 'uploadEndpoint.option3' },
  { value: 'uploadProxy', labelKey: 'uploadEndpoint.option4' }
];

// Users whose document predates the field have uploadEndpoint undefined —
// treat anything outside the enum as 'default'.
export const normalizeUploadEndpoint = (value?: string | null): EndpointKey =>
  UPLOAD_ENDPOINT_OPTIONS.some((option) => option.value === value)
    ? (value as EndpointKey)
    : 'default';
